import UserAgent from 'js/lib/useragent';

import inServerContext from 'bundles/ssr/util/inServerContext';

// Matches only legacy EdgeHTML Edge ("Edge/18.x"), not modern Chromium Edge ("Edg/126.x").
// Deliberately narrower than js/lib/useragent's browser.name === 'Edge' check (which, after
// the fix in DEVEXFE-1400, correctly detects modern Edge too) — preserves this feature's
// existing behavior on modern Edge until its Edge support is explicitly revisited.
const LEGACY_EDGE_RE = /Edge\//;

export const isVideoHighlightingEnabled = (): boolean => {
  if (inServerContext) {
    return false;
  }

  const userAgentInfo = new UserAgent(navigator.userAgent);
  const isIE = userAgentInfo.browser && userAgentInfo.browser.name === 'IE';
  const isLegacyEdge = LEGACY_EDGE_RE.test(navigator.userAgent);

  // Feature is not supported on IE or legacy (EdgeHTML) Edge
  if (isIE || isLegacyEdge) {
    return false;
  }

  return true;
};
